'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadSnowplowScript;

var _constants = require('./constants');

function loadSnowplowScript() {
  var globalSnowplowName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hudlTrackingSnowplow';

  // Based on vendor code for loading their script
  // Modified for the following:
  // - to comply with linting rules and avoid unnecessary parameters
  // - to fix a bug where arguments were not being passed through so updated to ...args
  if (!window[globalSnowplowName]) {
    window.GlobalSnowplowNamespace = window.GlobalSnowplowNamespace || [];
    window.GlobalSnowplowNamespace.push(globalSnowplowName);
    window[globalSnowplowName] = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (window[globalSnowplowName].q = window[globalSnowplowName].q || []).push(args);
    };

    var spScript = document.createElement('script');
    document.head.appendChild(spScript);

    window[globalSnowplowName].q = window[globalSnowplowName].q || [];

    spScript.async = true;
    spScript.src = _constants.SNOWPLOW_CDN;

    var scriptTag = document.getElementsByTagName('script')[0];
    scriptTag.parentNode.insertBefore(spScript, scriptTag);
  }
}
module.exports = exports['default'];